import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import EdiText from 'react-editext';
import { useHistory } from 'react-router';
import styles from './user-search.module.scss';
import { store } from 'react-notifications-component';
import SearchIcon from '@material-ui/icons/Search';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Countdown from 'react-countdown';
import BathtubIcon from '@material-ui/icons/Bathtub';
import ArrowForward from '@material-ui/icons/ArrowForward';
import WarningIcon from '@material-ui/icons/Warning';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import { ErrorInfo, isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import PhoneInput from 'react-phone-input-2';
import { trackPage } from '../../../shared/services/utils/tracking/tracking.service';
import { getModuleName } from '../../shared/services/user.service';
import { PUBLIC_PATH, APP_ROUTES } from '../../../shared/config/routes-config';
import { AddUserModal } from './components/add-user-modal/add-user-modal.component';
import { FormElementData } from '../../../shared/interfaces/form-element-data.interface';
import {
  getUserByPhone,
  updateUser,
  getUserByEmail
} from '../../../shared/services/data/user.data';
import { UserUIModel } from '../../../shared/ui-models/user.ui-model';
import Button, { ButtonSize } from '../../../shared/components/core-ui/button/button.component';
import { GenderPickerComponent } from '../../../shared/components/core-ui/gender-picker/gender-picker.component';
import { ReservationUiModel } from '../../../shared/ui-models/reservation.ui-model';
import { BookingRequestUiModel } from '../../../shared/ui-models/booking-request.ui-model';
import { ReservationStatus } from '../../../shared/enums/reservation-status';
import { BookingRequestStatus } from '../../../shared/enums/booking-request-status.enum';
import {
  getUserReservations,
  getUserBookingRequests,
  getUserLockStatus,
  unlockUser
} from '../../shared/services/data.service';
import { searchInUnitTypes } from '../../../shared/services/data/unit-type.data';
import { UnitTypeUiModel } from '../../../shared/ui-models/unit-type.ui-model';
import { ReservationMode } from '../../../shared/enums/reservation-mode.enum';
import {
  InputText,
  InputTextType
} from '../../../shared/components/core-ui/input-text/input-text.component';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
      fontSize: '1.5rem'
    }
  }
});
const useSelectedRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
      fontSize: '1.5rem'
      // backgroundColor: '#ffa358'
    }
  }
});

export const UserSearchContainer = () => {
  const [users, setUsers] = useState<UserUIModel[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<string>();
  const [userLockStatus, setUserLockStatus] = useState<{
    [userId: string]: boolean | undefined;
  }>({});
  const [searchNumber, setSearchNumber] = useState<FormElementData<string>>({
    value: '',
    isValid: false
  });
  const [searchEmail, setSearchEmail] = useState<FormElementData<string>>({
    value: '',
    isValid: false
  });
  const [userReservations, setUserReservations] = useState<ReservationUiModel[]>();
  const [userBookingRequests, setUserBookingRequests] = useState<BookingRequestUiModel[]>();
  const [userUnits, setUserUnits] = useState<UnitTypeUiModel[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingReservations, setIsLoadingReservations] = useState<boolean>(false);
  const [isLoadingBookings, setIsLoadingBookings] = useState<boolean>(false);
  const [isLoadingUnits, setIsLoadingUnits] = useState<boolean>(false);
  const [showNotFound, setShowNotFound] = useState<boolean>(false);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const { t } = useTranslation();
  const history = useHistory();
  const selectedUser = users.find((existingUser) => existingUser.id === selectedUserId) || users[0];

  useEffect(() => {
    trackPage('user-search');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const counterRenderer = ({
    hours,
    minutes,
    seconds
  }: {
    hours: number;
    minutes: number;
    seconds: number;
  }) => {
    // Render a countdown
    return (
      <b className={styles['user-search-container__reservation-item__status--highlighted']}>
        {hours}:{minutes}:{seconds}
      </b>
    );
  };
  function getLockStatus(userId: string) {
    getUserLockStatus(userId).then((response) => {
      if (!isErrorInfo(response)) {
        setUserLockStatus((previousStatus) => ({
          ...previousStatus,
          [userId]: response.isEmailLocked
        }));
      }
    });
  }
  function unlockUserEmail(userId: string) {
    unlockUser(userId).then((response) => {
      if (!isErrorInfo(response)) {
        store.addNotification({
          id: 'unlock-user-success',
          title: 'successfully unlocked user',
          message: 'user now can login again',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut']
        });
        getLockStatus(userId);
      }
    });
  }
  function ReservationRow(props: { reservation: ReservationUiModel }) {
    const { reservation } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    const selectedClasses = useSelectedRowStyles();

    return (
      <>
        <TableRow
          className={
            reservation.status === ReservationStatus.CHECKED_IN_STARTED
              ? selectedClasses.root
              : classes.root
          }
          onClick={() => {
            history.push(
              (APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH.replace(
                ':id',
                reservation?.id as string
              )
            );
          }}
        >
          <TableCell component="th" scope="row">
            {reservation.id}
          </TableCell>
          <TableCell>{reservation.unitName}</TableCell>
          <TableCell>
            <div
              className={`${styles['user-search-container__reservation-item__status']} ${
                styles[`user-search-container__reservation-item__status--${reservation?.status}`]
              }`}
            >
              {reservation.status ? reservation.status.replace('_', ' ') : ''}{' '}
              {reservation.status === ReservationStatus.CONFIRMATION_PENDING ||
              reservation.status === ReservationStatus.CHECKED_IN_STARTED ? (
                <Countdown
                  date={
                    new Date(
                      new Date(Number(reservation.checkinExpiresAt)).getTime() + 60 * 60 * 24 * 1000
                    )
                  }
                  renderer={counterRenderer}
                />
              ) : (
                ''
              )}
            </div>
            {reservation.guestIds.length === 0 && (
              <div
                className={`${styles['user-search-container__reservation-item__status']} ${
                  styles[`user-search-container__reservation-item__status--canceled`]
                }`}
              >
                {reservation.guestIds.length === 0 ? 'Guest Data incomplete' : ''}
              </div>
            )}
          </TableCell>
          <TableCell>{new Date(reservation.checkInDate).toDateString()}</TableCell>
          <TableCell>{new Date(reservation.checkOutDate).toDateString()}</TableCell>
        </TableRow>
        <TableRow></TableRow>
      </>
    );
  }
  function BookingRow(props: { reservation: BookingRequestUiModel }) {
    const { reservation } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    const selectedClasses = useSelectedRowStyles();

    return (
      <>
        <TableRow
          className={
            reservation.status === BookingRequestStatus.IN_SCREENING
              ? selectedClasses.root
              : classes.root
          }
        >
          {/* <TableCell>{reservation.guestInfo.name}</TableCell> */}

          <TableCell>
            <div
              className={`${styles['user-search-container__reservation-item__status']} ${
                styles[`user-search-container__reservation-item__status--${reservation?.status}`]
              }`}
            >
              {reservation.status ? reservation.status.replace('_', ' ') : ''}{' '}
              {reservation.status === BookingRequestStatus.IN_SCREENING ? (
                <Countdown
                  date={
                    new Date(new Date(Number(reservation.bookedAt)).getTime() + 60 * 60 * 24 * 1000)
                  }
                  renderer={counterRenderer}
                />
              ) : (
                ''
              )}
            </div>
          </TableCell>
          <TableCell>
            {new Date(Number(reservation.bookingInfo.checkInDate)).toDateString()}
          </TableCell>
          <TableCell>
            {new Date(Number(reservation.bookingInfo.checkOutDate)).toDateString()}
          </TableCell>
          <TableCell component="th" scope="row">
            {reservation.requestId}
          </TableCell>
        </TableRow>
        <TableRow></TableRow>
      </>
    );
  }

  function updateUserData(selectedUser: UserUIModel, userData: Partial<UserUIModel>) {
    const userDataWithID: UserUIModel = { ...userData, id: selectedUser?.id };
    updateUser(userDataWithID, getModuleName()).then((response: UserUIModel | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setUsers((previousUsers) =>
          previousUsers.map((existingUser) =>
            existingUser.id === response.id ? { ...existingUser, ...response } : existingUser
          )
        );
      } else {
        if (response.status === 403) {
          store.addNotification({
            id: 'update-user-failed',
            title: 'Permission not allowed',
            message: "Seems like you don't have the right permissions to update users",
            type: 'danger',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut']
          });
        } else if (response.status === 400) {
          store.addNotification({
            id: 'update-user-failed',
            title: 'Invalid data entered!',
            message: response.errorMessage || 'please try again later, or contact administrator',
            type: 'danger',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut']
          });
        } else {
          store.addNotification({
            id: 'update-user-failed',
            title: 'Something went wrong',
            message:
              response.message ||
              response.errorMessage ||
              'please try again later, or contact administrator',
            type: 'danger',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut']
          });
        }
      }
    });
  }

  function loadUserDetails(selectedUser: UserUIModel) {
    if (!selectedUser.id) {
      return;
    }

    getLockStatus(selectedUser.id);
    setSelectedUserId(selectedUser.id);
    setUserReservations([]);
    setUserBookingRequests([]);
    setUserUnits([]);

    setIsLoadingReservations(true);
    getUserReservations(selectedUser.id).then((response: ReservationUiModel[] | ErrorInfo) => {
      setIsLoadingReservations(false);
      if (!isErrorInfo(response)) {
        setUserReservations(response);
      }
    });

    setIsLoadingBookings(true);
    getUserBookingRequests(selectedUser.id).then(
      (response: BookingRequestUiModel[] | ErrorInfo) => {
        setIsLoadingBookings(false);
        if (!isErrorInfo(response)) {
          setUserBookingRequests(response);
        }
      }
    );

    setIsLoadingUnits(true);
    searchInUnitTypes(getModuleName(), { landlordId: selectedUser.id }).then(
      (response: UnitTypeUiModel[] | ErrorInfo) => {
        setIsLoadingUnits(false);
        if (!isErrorInfo(response)) {
          setUserUnits(response);
        }
      }
    );
  }

  const handleGetUserByPhoneNumber = () => {
    if (searchNumber && searchNumber.value !== '') {
      setIsLoading(true);
      setUsers([]);
      setSelectedUserId(undefined);
      setUserLockStatus({});
      setUserReservations([]);
      setUserBookingRequests([]);
      setUserUnits([]);
      getUserByPhone(searchNumber.value, getModuleName(), { returnAll: true }).then(
        (response: UserUIModel[] | ErrorInfo) => {
          setIsLoading(false);
          if (!isErrorInfo(response)) {
            setShowNotFound(false);
            setUsers(response);
            response.forEach((searchedUser) => {
              if (searchedUser.id) {
                getLockStatus(searchedUser.id);
              }
            });
            if (response.length > 0) {
              loadUserDetails(response[0]);
            }
          } else {
            if (response.status === 404) {
              setShowNotFound(true);
            }
            setUsers([]);
            setSelectedUserId(undefined);
          }
        }
      );
    }
  };

  const handleGetUserByEmail = () => {
    if (searchEmail && searchEmail.value !== '') {
      setIsLoading(true);
      setUsers([]);
      setSelectedUserId(undefined);
      setUserLockStatus({});
      setUserReservations([]);
      setUserBookingRequests([]);
      setUserUnits([]);
      getUserByEmail(searchEmail.value, getModuleName(), { returnAll: true }).then(
        (response: UserUIModel[] | ErrorInfo) => {
          setIsLoading(false);
          if (!isErrorInfo(response)) {
            setShowNotFound(false);
            setUsers(response);
            response.forEach((searchedUser) => {
              if (searchedUser.id) {
                getLockStatus(searchedUser.id);
              }
            });
            if (response.length > 0) {
              loadUserDetails(response[0]);
            }
          } else {
            if (response.status === 404) {
              setShowNotFound(true);
            }
            setUsers([]);
            setSelectedUserId(undefined);
          }
        }
      );
    }
  };

  return (
    <div className={styles['user-search-container']}>
      <div className="text-4xl font-recoleta font-semibold text-neutral-500">
        {t('USER_MODULE.SEARCH_CONTAINER.TITLE')}
      </div>
      <div className={styles['user-search-container__search']}>
        <PhoneInput
          country={'eg'}
          inputProps={{
            name: 'Search by phone number',
            required: true
          }}
          value={searchNumber.value}
          onChange={(phone) => {
            phone
              ? setSearchNumber({ value: `+${phone}`, isValid: true })
              : setSearchNumber({ value: `${phone}`, isValid: false });
          }}
        />
        <Button
          className={styles['user-search-container__search__btn']}
          onClick={() => {
            handleGetUserByPhoneNumber();
          }}
          loading={isLoading}
          tracking={{
            action: 'search',
            category: 'user',
            label: 'search-user'
          }}
          size={ButtonSize.medium}
        >
          <SearchIcon></SearchIcon>
        </Button>
      </div>
      <div className={styles['user-search-container__search']}>OR</div>
      <div className={styles['user-search-container__search']}>
        <InputText
          data={{
            placeholder: 'Search by email address',
            value: searchEmail.value
          }}
          config={{
            type: InputTextType.email
          }}
          eventHandlers={{
            onChangeHandler: (value, isValid) => {
              if (isValid) {
                setSearchEmail({ value, isValid });
              }
            }
          }}
        />
        <Button
          className={styles['user-search-container__search__btn']}
          onClick={() => {
            handleGetUserByEmail();
          }}
          loading={isLoading}
          tracking={{
            action: 'search',
            category: 'user',
            label: 'search-user'
          }}
          size={ButtonSize.medium}
        >
          <SearchIcon></SearchIcon>
        </Button>
      </div>
      {!showNotFound && users.length === 0 && (
        <div className={styles['user-search-container__content']}>
          <div className={styles['user-search-container__content__illustration']}>
            <img
              src={`${PUBLIC_PATH}/assets/jpeg/pointing-up.webp`}
              className={styles['user-search-container__content__illustration__image']}
              alt="no-data"
            />
            Type phone number to search or Add new
          </div>
        </div>
      )}
      {showNotFound && (
        <div className={styles['user-search-container__content']}>
          <div className={styles['user-search-container__content__illustration']}>
            <img
              src={`${PUBLIC_PATH}/assets/jpeg/no-results-found.jpg`}
              className={styles['user-search-container__content__illustration__image']}
              alt="no-data"
            />
            Phone number not in our records, click below to create user
            <br />
            <Button
              className={styles['user-search-container__search__btn']}
              onClick={() => {
                setShowAddModal(true);
              }}
              tracking={{
                action: 'add',
                category: 'user',
                label: 'add-user'
              }}
              size={ButtonSize.medium}
            >
              Add User
            </Button>
          </div>
        </div>
      )}
      {users.length > 0 && (
        <div className={styles['user-search-container__details-wrapper']}>
          <div className="mb-6 flex items-start justify-between gap-4">
            <div>
              <div className="text-3xl font-gilroy-medium font-semibold text-neutral-500">
                Matching users {`(${users.length})`}
              </div>
              <div className="mt-2 max-w-6xl text-[15px] leading-7 text-gray-700 font-gilroy-medium">
                Edit any user directly, then click Show activity to load reservations, bookings, and
                units.
              </div>
            </div>
          </div>
          <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2">
            {users.map((searchResultUser, index) => {
              const isSelected = selectedUserId === searchResultUser.id;
              const isLocked = searchResultUser.id && userLockStatus[searchResultUser.id] === true;
              const isUnlocked =
                searchResultUser.id && userLockStatus[searchResultUser.id] === false;
              const userCardKey =
                searchResultUser.id ||
                searchResultUser.email ||
                searchResultUser.phone ||
                `user-card-${index}`;

              return (
                <div
                  key={userCardKey}
                  className={`rounded-[24px] border bg-gradient-to-br from-white via-creams-50 to-white p-6 transition-all duration-200 hover:-translate-y-0.5 ${
                    isSelected
                      ? 'border-primary-500 shadow-[0_24px_55px_rgba(35,124,88,0.16)] ring-1 ring-primary-100'
                      : 'border-gray-200 shadow-[0_18px_45px_rgba(17,18,18,0.08)] hover:shadow-[0_24px_55px_rgba(17,18,18,0.12)]'
                  }`}
                >
                  <div className="mb-7 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
                    <div>
                      <div className="mb-3 flex flex-wrap items-center gap-3">
                        <div className="text-4xl font-gilroy-medium text-neutral-500">
                          {searchResultUser.name || 'Unnamed user'}
                        </div>
                        {searchResultUser.role && (
                          <div className="inline-flex items-center rounded-full border border-primary-100 bg-primary-50 px-3 py-1.5 text-sm uppercase tracking-[0.16em] text-primary-700 font-gilroy-bold">
                            {searchResultUser.role}
                          </div>
                        )}
                      </div>
                      <div className="break-all text-lg text-gray-700 font-gilroy-medium">
                        {searchResultUser.id || 'No user id'}
                      </div>
                    </div>
                    <button
                      type="button"
                      className={`inline-flex shrink-0 items-center justify-center rounded-full border px-5 py-2.5 text-base transition-colors font-gilroy-medium ${
                        isSelected
                          ? 'border-primary-600 bg-primary-600 text-white shadow-sm'
                          : 'border-gray-200 bg-white text-neutral-500 hover:border-primary-200 hover:bg-primary-50 hover:text-primary-700'
                      }`}
                      onClick={() => {
                        if (!isSelected) {
                          loadUserDetails(searchResultUser);
                        }
                      }}
                    >
                      {isSelected ? 'Showing activity' : 'Show activity'}
                    </button>
                  </div>

                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <div className="min-w-0 rounded-2xl border border-gray-200 bg-white/90 px-4 py-4 backdrop-blur-sm">
                      <div className="mb-2 text-lg uppercase tracking-[0.16em] text-gray-700 font-gilroy-bold">
                        Name
                      </div>
                      <div className="break-words text-xl text-neutral-500 font-gilroy-medium">
                        <EdiText
                          type="text"
                          value={searchResultUser.name || ''}
                          onSave={(val) => {
                            updateUserData(searchResultUser, { name: val });
                          }}
                        />
                      </div>
                    </div>

                    <div className="min-w-0 rounded-2xl border border-gray-200 bg-white/90 px-4 py-4 backdrop-blur-sm">
                      <div className="mb-2 text-lg uppercase tracking-[0.16em] text-gray-700 font-gilroy-bold">
                        Phone number
                      </div>
                      <div className="break-words text-xl text-neutral-500 font-gilroy-medium">
                        <EdiText
                          type="text"
                          value={searchResultUser.phone || ''}
                          onSave={(val) => {
                            updateUserData(searchResultUser, { phone: val });
                          }}
                        />
                      </div>
                    </div>

                    <div className="min-w-0 rounded-2xl border border-gray-200 bg-white/90 px-4 py-4 backdrop-blur-sm">
                      <div className="mb-2 text-lg uppercase tracking-[0.16em] text-gray-700 font-gilroy-bold">
                        Email
                      </div>
                      <div className="break-words text-xl text-neutral-500 font-gilroy-medium">
                        <EdiText
                          type="text"
                          value={searchResultUser.email || ''}
                          onSave={(val) => {
                            updateUserData(searchResultUser, { email: val });
                          }}
                        />
                      </div>
                    </div>
                    <div className="min-w-0 rounded-2xl border border-gray-200 bg-white/90 px-4 py-4 backdrop-blur-sm">
                      <div className="mb-2 text-lg uppercase tracking-[0.16em] text-gray-700 font-gilroy-bold">
                        Account status
                      </div>
                      <div className="break-words text-xl text-neutral-500 font-gilroy-medium">
                        <div
                          className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-base font-gilroy-medium ${
                            isLocked
                              ? 'border-red-100 bg-red-50 text-red-600'
                              : isUnlocked
                              ? 'border-primary-100 bg-primary-50 text-primary-700'
                              : 'border-gray-200 bg-gray-100 text-gray-700'
                          }`}
                        >
                          {isLocked ? (
                            <LockIcon className="!h-4 !w-4" />
                          ) : (
                            <LockOpenIcon className="!h-4 !w-4" />
                          )}
                          {isLocked ? 'Locked' : isUnlocked ? 'Active' : 'Checking status'}
                        </div>
                      </div>
                    </div>
                    <div className="min-w-0 rounded-2xl border border-gray-200 bg-white/90 px-4 py-4 backdrop-blur-sm md:col-span-2">
                      <div className="mb-2 text-xs uppercase tracking-[0.16em] text-gray-700 font-gilroy-bold">
                        Gender
                      </div>
                      <div className="break-words text-xl text-neutral-500 font-gilroy-medium">
                        <GenderPickerComponent
                          data={{ selectedItemValue: searchResultUser.gender as any }}
                          config={{ hideMixed: true }}
                          eventHandlers={{
                            itemSelectedHandler: (genderChanged) => {
                              updateUserData(searchResultUser, { gender: genderChanged as any });
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {isLocked && (
                    <div className="mt-5 flex justify-end border-t border-gray-100 pt-4">
                      <Button
                        onClick={() => {
                          unlockUserEmail(searchResultUser.id as string);
                        }}
                        tracking={{
                          action: 'unlock',
                          category: 'user',
                          label: 'unlock-user'
                        }}
                        size={ButtonSize.medium}
                      >
                        unlock account
                      </Button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {selectedUser && userUnits && userUnits.length > 0 && (
            <div className={styles['user-search-container__details-wrapper__user-details']}>
              <div className={styles['user-search-container__content__title']}>
                Homeowner Units
                {` ${userUnits && userUnits.length ? '(' + userUnits.length + ')' : ''}`}
              </div>
              {isLoadingUnits ? (
                <div className={styles['user-search-container__loader']}>
                  <img src={`${PUBLIC_PATH}/assets/svgs/loader.svg`} alt="loader" />
                </div>
              ) : (
                <div className={styles['user-search-container__table']}>
                  {userUnits &&
                    userUnits.map((unitType) => (
                      <div
                        className={`${styles['user-search-container__unit-type-item']} ${
                          unitType.isListed
                            ? styles['user-search-container__unit-type-item--published']
                            : ''
                        }`}
                      >
                        <div
                          className={styles['user-search-container__unit-type-item__image-wrapper']}
                        >
                          <img
                            className={`${
                              styles['user-search-container__unit-type-item__image-wrapper__image']
                            } ${
                              unitType.isListed
                                ? ''
                                : styles[
                                    'user-search-container__unit-type-item__image-wrapper__image--unpublished'
                                  ]
                            }`}
                            alt="unit-type"
                            src={
                              unitType?.coverImage ||
                              `${PUBLIC_PATH}/assets/pngs/unit-type-default.png`
                            }
                          />
                        </div>
                        <div className={styles['user-search-container__unit-type-item__header']}>
                          <div
                            className={`${
                              styles['user-search-container__unit-type-item__header__title']
                            } ${
                              !unitType.name
                                ? styles[
                                    'user-search-container__unit-type-item__header__title--untitled'
                                  ]
                                : ''
                            } `}
                          >
                            {unitType.name ||
                              t('UNIT_TYPE_MODULE.LIST_CONTAINER.UNTITLED_UNIT_TYPE')}
                            {/* <p
                  className={
                    styles['user-search-container__unit-type-item__header__title__created-by']
                  }
                >
                  {t('UNIT_TYPE_MODULE.LIST_CONTAINER.MODIFIED_BY')}
                  <span>{unitType.modifiedByUsername}</span>
                </p> */}
                          </div>
                          {!unitType.propertyName && (
                            <div
                              className={
                                styles[
                                  'user-search-container__unit-type-item__header-details--error'
                                ]
                              }
                            >
                              <WarningIcon
                                className={
                                  styles[
                                    'user-search-container__unit-type-item__header-details--error_icon'
                                  ]
                                }
                              />
                              Unit Type is not assigned to any Projects
                            </div>
                          )}
                          <div
                            className={
                              styles['user-search-container__unit-type-item__header-details']
                            }
                          >
                            <div
                              className={
                                styles[
                                  'user-search-container__unit-type-item__header-details_property-details'
                                ]
                              }
                            >
                              <div>
                                <div
                                  className={
                                    styles[
                                      'user-search-container__unit-type-item__header-details_property-details-name'
                                    ]
                                  }
                                >
                                  property Name:
                                  <a
                                    href={`${process.env.PUBLIC_URL}/properties/edit/${unitType.propertyId}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {unitType.propertyName}
                                    <ArrowForward color="inherit" fontSize="inherit" />
                                  </a>
                                </div>
                                <div
                                  className={
                                    styles[
                                      'user-search-container__unit-type-item__header-details_property-details-name'
                                    ]
                                  }
                                >
                                  Rooms:{' '}
                                  {unitType.units && unitType.units.length > 0
                                    ? unitType.units?.map((unit) => (
                                        <div
                                          className={
                                            styles[
                                              'user-search-container__unit-type-item__room-name'
                                            ]
                                          }
                                        >
                                          {unit.shortName}
                                        </div>
                                      ))
                                    : ' No rooms'}
                                </div>
                              </div>
                              <div
                                className={
                                  styles[
                                    'user-search-container__unit-type-item__header-details_property-details-area'
                                  ]
                                }
                              >
                                area:
                                <a
                                  href={`${process.env.PUBLIC_URL}/properties/edit/${unitType.areaId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {unitType.area}{' '}
                                  <ArrowForward color="inherit" fontSize="inherit" />
                                </a>
                              </div>
                            </div>
                            {unitType.availableFrom && (
                              <div
                                className={
                                  styles[
                                    'user-search-container__unit-type-item__header-details_property-availability'
                                  ]
                                }
                              >
                                <span>
                                  Available from:{' '}
                                  {unitType.availableFrom &&
                                    new Date(unitType.availableFrom).toDateString()}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={styles['user-search-container__unit-type-item__content']}>
                          <div
                            className={
                              styles['user-search-container__unit-type-item__content__responses']
                            }
                          >
                            <AttachMoneyIcon
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__icon'
                                ]
                              }
                            />
                            <span
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__number'
                                ]
                              }
                            >
                              {unitType?.unitPrice || 0} &nbsp;
                            </span>
                            <span
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__response-text'
                                ]
                              }
                            >
                              {unitType?.reservationMode === ReservationMode.MONTHLY
                                ? t('UNIT_TYPE_MODULE.LIST_CONTAINER.MONTHLY_PRICE')
                                : t('UNIT_TYPE_MODULE.LIST_CONTAINER.NIGHTLY_PRICE')}
                            </span>
                          </div>
                          <div
                            className={
                              styles['user-search-container__unit-type-item__content__responses']
                            }
                          >
                            <MeetingRoomIcon
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__icon'
                                ]
                              }
                            />
                            <span
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__number'
                                ]
                              }
                            >
                              {unitType?.units?.length || 0} &nbsp;
                            </span>
                            <span
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__response-text'
                                ]
                              }
                            >
                              {t('UNIT_TYPE_MODULE.LIST_CONTAINER.UNITS_COUNT')}
                            </span>
                          </div>
                          <div
                            className={
                              styles['user-search-container__unit-type-item__content__responses']
                            }
                          >
                            <BathtubIcon
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__icon'
                                ]
                              }
                            />
                            <span
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__number'
                                ]
                              }
                            >
                              {unitType?.amenities?.length || 0} &nbsp;
                            </span>
                            <span
                              className={
                                styles[
                                  'user-search-container__unit-type-item__content__responses__response-text'
                                ]
                              }
                            >
                              {t('UNIT_TYPE_MODULE.LIST_CONTAINER.AMENITIES_COUNT')}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}
          <div className={styles['user-search-container__details-wrapper__user-details']}>
            <div className={styles['user-search-container__content__title']}>
              Reservations
              {` ${
                userReservations && userReservations.length
                  ? '(' + userReservations.length + ')'
                  : ''
              }`}
            </div>
            {isLoadingReservations ? (
              <div className={styles['user-search-container__loader']}>
                <img src={`${PUBLIC_PATH}/assets/svgs/loader.svg`} alt="loader" />
              </div>
            ) : userReservations && userReservations.length ? (
              <div className={styles['user-search-container__table']}>
                <TableContainer component={Paper}>
                  <Table aria-label="table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Id #</TableCell>
                        <TableCell>Room Name</TableCell>
                        <TableCell>Tags</TableCell>
                        <TableCell>Check In</TableCell>
                        <TableCell>Check Out</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userReservations?.length > 0 &&
                        userReservations?.map((reservation: ReservationUiModel) => (
                          <ReservationRow key={reservation.id} reservation={reservation} />
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            ) : (
              <div className={styles['user-search-container__content__illustration']}>
                <img
                  src={`${PUBLIC_PATH}/assets/jpeg/no-results-found.jpg`}
                  className={styles['user-search-container__content__illustration__image']}
                  alt="no-data"
                />
                No previous reservation.
              </div>
            )}
          </div>
          <div className={styles['user-search-container__details-wrapper__user-details']}>
            <div className={styles['user-search-container__content__title']}>
              Booking Requests
              {` ${
                userBookingRequests && userBookingRequests.length
                  ? '(' + userBookingRequests.length + ')'
                  : ''
              }`}
            </div>
            {isLoadingBookings ? (
              <div className={styles['user-search-container__loader']}>
                <img src={`${PUBLIC_PATH}/assets/svgs/loader.svg`} alt="loader" />
              </div>
            ) : userBookingRequests && userBookingRequests.length > 0 ? (
              <div className={styles['user-search-container__table']}>
                <TableContainer component={Paper}>
                  <Table aria-label="table">
                    <TableHead>
                      <TableRow>
                        {/* <TableCell>Contact Name</TableCell> */}
                        <TableCell>Tags</TableCell>
                        <TableCell>Check In</TableCell>
                        <TableCell>Check Out</TableCell>
                        <TableCell>Id #</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {userBookingRequests?.length > 0 &&
                        userBookingRequests?.map((reservation: BookingRequestUiModel) => (
                          <BookingRow key={reservation.id} reservation={reservation} />
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            ) : (
              <div className={styles['user-search-container__content__illustration']}>
                <img
                  src={`${PUBLIC_PATH}/assets/jpeg/no-results-found.jpg`}
                  className={styles['user-search-container__content__illustration__image']}
                  alt="no-data"
                />
                No previous requests.
              </div>
            )}
          </div>
        </div>
      )}
      <AddUserModal
        config={{ showModal: showAddModal }}
        eventHandlers={{
          cancelHandler: () => {
            setShowAddModal(false);
          },
          addUserHandler: (userModal: UserUIModel) => {
            setShowAddModal(false);
            // handleNewAreaSubmit(areaName, order);
          }
        }}
      />
    </div>
  );
};

export default connect()(UserSearchContainer);
